import React, { useContext } from 'react';
import './SeachPagination.css';
import { GetUserContext } from '../Context/GetUserContext';
import ReactDatePicker, { registerLocale } from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";
import "react-datepicker/dist/react-datepicker.css";

registerLocale("pt-BR", ptBR);

const SeachPagination = ({ currentPage, Company_ID }) => {
    const { size, setFetchTimestamp, dataInicial, setDataInicial, dataFinal, setDataFinal } = useContext(GetUserContext);
    const parseDate = (value) => value ? new Date(value + 'T00:00:00') : null;

    const formatToLocalDateString = (date) => {
        if (!date) return '';
        const year = date.getFullYear();
        const month = `${date.getMonth() + 1}`.padStart(2, '0');
        const day = `${date.getDate()}`.padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleSearch = () => {
        if (dataInicial || dataFinal) {
            setFetchTimestamp(Date.now());
        }

    };
    const handleClear = () => {
        if (dataInicial || dataFinal) {
            setDataInicial('')
            setDataFinal('')
            setFetchTimestamp(Date.now());
        }

    };

    return (
        <div className='area-pagination-filter'>
            {
                size?.categoria !== 'xlarge' && size?.categoria !== 'large' ?
                    (
                        <>
                            <div className="d-flex align-items-start gap-3">
                                <div className="d-flex flex-column">
                                    <label htmlFor="data-inicial" className="form-label  mb-1">Data Inicial:</label>
                                    <ReactDatePicker
                                        selected={parseDate(dataInicial)}
                                        onChange={(date) => setDataInicial(formatToLocalDateString(date))}
                                        dateFormat="dd/MM/yyyy"
                                        locale="pt-BR"
                                        placeholderText="dd/mm/aaaa"
                                        className="form-control"
                                        id="data-inicial"
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                    />
                                </div>
                                <div className="d-flex flex-column">
                                    <label htmlFor="data-final" className="form-label mb-1">Data Final:</label>
                                    <ReactDatePicker
                                        selected={parseDate(dataFinal)}
                                        onChange={(date) => setDataFinal(formatToLocalDateString(date))}
                                        dateFormat="dd/MM/yyyy"
                                        locale="pt-BR"
                                        placeholderText="dd/mm/aaaa"
                                        className="form-control"
                                        id="data-final"
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                    />
                                </div>


                            </div>
                            <div className='d-flex align-items-center justify-content-between'>
                                <div className="d-flex w-50 flex-column justify-content-end">
                                    <label className="form-label mb-1">&nbsp;</label>
                                    <button className="btn btn-outline-secondary" onClick={handleSearch}>
                                        Pesquisar
                                    </button>
                                </div>

                                <div style={{ marginLeft: "10px", visibility: "hidden", userSelect: "none" }}>*</div>

                                {
                                    dataInicial?.length > 1 ?
                                        (<div className="d-flex w-50  flex-column justify-content-end">
                                            <label className="form-label mb-1">&nbsp;</label>
                                            <button className="btn btn-outline-secondary" onClick={handleClear}>
                                                Limpar
                                            </button>
                                        </div>)
                                        :
                                        (<></>)
                                }
                            </div>
                        </>
                    )
                    :
                    (
                        <div className="d-flex align-items-start gap-3">
                            <div className="d-flex flex-column">
                                <label htmlFor="data-inicial" className="form-label mb-1">Data Inicial:</label>
                                <ReactDatePicker
                                    selected={parseDate(dataInicial)}
                                    onChange={(date) => setDataInicial(formatToLocalDateString(date))}
                                    dateFormat="dd/MM/yyyy"
                                    locale="pt-BR"
                                    placeholderText="dd/mm/aaaa"
                                    className="form-control"
                                    id="data-inicial"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                />
                            </div >
                            <div className="d-flex flex-column">
                                <label htmlFor="data-final" className="form-label mb-1">Data Final:</label>
                                <ReactDatePicker
                                    selected={parseDate(dataFinal)}
                                    onChange={(date) => setDataFinal(formatToLocalDateString(date))}
                                    dateFormat="dd/MM/yyyy"
                                    locale="pt-BR"
                                    placeholderText="dd/mm/aaaa"
                                    className="form-control"
                                    id="data-final"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                />
                            </div>
                            <div className="d-flex flex-column justify-content-end">
                                <label className="form-label mb-1">&nbsp;</label>
                                <button className="btn btn-outline-secondary" onClick={handleSearch}>
                                    Pesquisar
                                </button>
                            </div>

                            {
                                dataInicial?.length > 1 ?
                                    (<div className="d-flex flex-column justify-content-end">
                                        <label className="form-label mb-1">&nbsp;</label>
                                        <button className="btn btn-outline-secondary" onClick={handleClear}>
                                            Limpar
                                        </button>
                                    </div>)
                                    :
                                    (<></>)
                            }

                        </div >
                    )
            }

            <hr />
        </div >
    );
};

export default SeachPagination;
